import React, { useState } from 'react';
import ImagePicker from '../../components/inputFields/ImagePicker';
import { Form, Formik } from 'formik';
import * as Yup from "yup";
import InputField from '../../components/inputFields/InputField';
import Button from '../../components/buttons/Button';
import { sanitizeMobile } from '../../utils/phone';

function OwnerDetails() {
    // State variables to manage selected images
    const [isEditing, setEditing] = useState(false);
    const [ownerImage, setOwnerImage] = useState(null);
    const [visitingCardImage, setVisitingCardImage] = useState(null);

    const handleOwnerImage = (file) => {
        setOwnerImage(file); // Save the selected Owner Image
    };

    const handleVisitingCardImage = (file) => {
        setVisitingCardImage(file); // Save the selected Visiting Card Image
    };

    const handleFormSubmit = async (values, { setSubmitting, resetForm }) => {
        setSubmitting(false);
    };

    const handleEditing = (value) => {
        setEditing(value);
    };

    return (
        <Formik
            initialValues={{
                owner_name: "",
                owner_email: "",
                owner_contact: "",
            }}
            validationSchema={Yup.object({
                owner_name: Yup.string().required("Please enter your Name"),
                owner_email: Yup.string().required("Please enter your Email"),
                owner_contact: Yup.string().required("Please enter your Phone Number"),
            })}
            onSubmit={handleFormSubmit}
        >
            {({ isSubmitting, setFieldValue }) => (
                <Form>
                    <div className="flex flex-row gap-4">
                        <div className="flex flex-col lg:flex-row gap-4">
                            {/* Owner Image Picker */}
                            <div className="w-48 h-48">
                                <ImagePicker
                                    preloadedImage={ownerImage}
                                    placeholder={"Upload Owner Image"}
                                    onImageSelect={handleOwnerImage}
                                    disabled={!isEditing}
                                />
                            </div>

                            {/* Visiting Card Image Picker */}
                            <div className="w-48 h-48">
                                <ImagePicker
                                    preloadedImage={visitingCardImage}
                                    placeholder={"Upload Visiting Card Image"}
                                    onImageSelect={handleVisitingCardImage}
                                    disabled={!isEditing}
                                />
                            </div>
                        </div>
                        <div className="flex flex-col xl:flex-row gap-4 w-full">
                            <div className="flex flex-col max-w-80 flex-1 w-full">
                                <InputField
                                    label="Owner Name"
                                    name="owner_name"
                                    type="text"
                                    placeholder="Enter your Name"
                                    disable={!isEditing}
                                    required
                                />
                                <InputField
                                    label="Owner Email"
                                    name="owner_email"
                                    type="email"
                                    placeholder="Enter your Email"
                                    disable={!isEditing}
                                    required
                                />
                                <InputField
                                    label="Contact Number"
                                    name="owner_contact"
                                    type="text"
                                    placeholder="Enter your Contact Number"
                                    disable={!isEditing}
                                    required
                                    onChange={(e) => setFieldValue('owner_contact', sanitizeMobile(e.target.value))}
                                />
                            </div>
                            {
                                isEditing ?

                                    <div className="flex flex-row max-h-12 gap-4">
                                        <Button
                                            type="submit"
                                            className="text-white bg-primary hover:bg-primary-dark font-sm rounded-lg text-lg w-full px-5 py-2.5 text-center"
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? "Loading..." : "Save"}
                                        </Button>
                                        <Button
                                            className="text-black bg-secondary hover:bg-primary-dark font-sm rounded-lg text-lg w-full px-5 py-2.5 text-center"
                                            disabled={isSubmitting}
                                            onClick={() => handleEditing(false)}
                                        >
                                            {"Cancel"}
                                        </Button>
                                    </div> :
                                    <div>
                                        <Button
                                            className="text-white bg-slate-800 hover:bg-primary-dark font-sm rounded-lg text-lg w-full px-5 py-2.5 text-center"
                                            onClick={() => handleEditing(true)}
                                        >
                                            {"Edit"}
                                        </Button>
                                    </div>
                            }
                        </div>
                    </div>
                </Form>
            )}
        </Formik>
    );
}

export default OwnerDetails;
